import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { AppCard } from '../general';
import { VendorBreakdownItem } from '../../models/reporting/reporting';

interface VendorTableProps {
  title: string;
  vendors: VendorBreakdownItem[];
  showDuration?: boolean;
  onVendorClick?: (vendor: string) => void;
}

const VendorTable = (props: VendorTableProps): JSX.Element => {
  const { title, vendors, showDuration = true, onVendorClick } = props;

  const successRateBody = (rowData: VendorBreakdownItem) => {
    const rate = rowData.count > 0 ? Math.round((rowData.successCount / rowData.count) * 100 * 10) / 10 : 0;
    const severity = rate >= 95 ? 'success' : rate >= 80 ? 'warning' : 'danger';
    return <Tag severity={severity} value={`${rate}%`} className="text-xs" />;
  };

  const durationBody = (rowData: VendorBreakdownItem) => {
    return <span>{Math.round(rowData.avgDurationMs).toLocaleString()} ms</span>;
  };

  const vendorBody = (rowData: VendorBreakdownItem) => {
    if (onVendorClick) {
      return (
        <span
          className="text-blue-600 hover:underline cursor-pointer font-medium"
          onClick={() => onVendorClick(rowData.vendor)}
        >
          {rowData.vendor}
        </span>
      );
    }
    return <span className="font-medium">{rowData.vendor}</span>;
  };

  return (
    <AppCard title={title}>
      <DataTable value={vendors} size="small" stripedRows emptyMessage="No data">
        <Column field="vendor" header="Vendor" body={vendorBody} />
        <Column field="count" header="Total" sortable />
        <Column field="successCount" header="Success" sortable />
        <Column field="failedCount" header="Failed" sortable />
        <Column header="Success Rate" body={successRateBody} />
        {showDuration && <Column header="Avg Duration" body={durationBody} />}
      </DataTable>
    </AppCard>
  );
};

export default VendorTable;
